import React from 'react'
import PublicRoutes from '../../routes/PublicRoutes'

function App() {
	return (
		<div className="App">
			<PublicRoutes />
		</div>
	)
}

export default App
